<template>
    <div>
        <van-uploader :after-read="afterRead" />
        <van-image :src="showImageSrc" class="img-show" />
    </div>
</template>

<script>
    import { uploadAchieveImg } from '@/api/student'

    export default {
        name: 'imageUplaoder',
        components: {
        },
        data() {
            return {
                showImageSrc: "",
            }
        },
        created() {
            let { obj, objKey } = this.attrs
            if (obj && objKey) {
                this.showImageSrc = obj[objKey]
            }
        },
        computed: {
            attrs() {
                return this.$attrs
            }
        },
        methods: {
            afterRead(file) {
                let formData = new FormData()
                formData.append('img_name', 'plan_image')
                formData.append('plan_image', file.file)
                uploadAchieveImg(formData).then(res => {
                    if (res.code === 10000) {
                        let { img_name, img_url } = res.result
                        this.attrs['obj'][this.attrs['objKey']] = img_name
                        this.showImageSrc = img_url
                    }
                }).catch(error => {
                    alert('上传失败')
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .img-show {
        width: 70%;
    }
</style>